import { THost } from '@/entities/room'
import { CertifiedBadge, Profile } from '@/entities/user'

export const UserInformation = ({
  picProfile,
  name,
  isCertificated,
  introduction,
}: THost) => {
  return (
    <div>
      <div className="mb-3 flex items-center gap-3">
        <Profile
          src={picProfile}
          alt={`${name} 호스트의 프로필 이미지`}
          size={60}
        />

        <div className="flex flex-col gap-2">
          <span className="typo-body1 font-semibold text-gray-900">{name}</span>
          {isCertificated && <CertifiedBadge />}
        </div>
      </div>

      <p className="typo-label1-reading min-h-[66px] w-60 font-normal whitespace-break-spaces text-gray-600">
        {introduction}
      </p>
    </div>
  )
}
